import { api } from "./axios";

export async function createNewSubscrib(data) {
    let res = await api.post("sub/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateSubscrib(id, data) {
    let res = await api.post("sub/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

export async function getAllSubscrib() {
    let res = await api.get("sub/getAll");
    if (res) return res.data.data;
    else return false;
}
export async function getDetailsSubscrib(id) {
    let res = await api.get("sub/show/" + id);
    if (res) return res.data.data;
    else return false;
}
export async function deleteSubscrib(id) {
    let res = await api.get("sub/remove/" + id);
    if (res) return res.data.data;
    else return false;
}
